import { defineComponent } from "vue";
import { refMethod, VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { PortalButtonData } from "../menuData";
import { FocusHandler } from "./focusHandler";
import PortalButton from "./portalButton";

export default /*#__PURE__*/ defineComponent(
{
    name: "portalBar",
    props:
    {
        selectedPortalCode: VueProp(String),
        portalButtonDatas: VueProp<PortalButtonData[]>(Array),
        focusHandler: VueProp<FocusHandler>()
    },
    emits:
    {
        selectPortal: null as unknown as (portalButtonData: PortalButtonData) => boolean,
    },
    render()
    {
        return (
            // this wrapper allows the scrollbar to properly display below the portal buttons instead of overlaying in IE11
            <div role="region" aria-label="Portals">
                <div class={Classes.portalBar} role="tabList">
                    {
                        this.portalButtonDatas.map(portalButtonData =>
                            <PortalButton
                                ref={refMethod<typeof PortalButton>((elem) => this.focusHandler.setPortalButton(portalButtonData, elem?.$el))}
                                portalButtonData={portalButtonData}
                                isSelected={this.selectedPortalCode === portalButtonData.portalCode}
                                focusHandler={this.focusHandler}
                                onSelectPortal={(portalButtonData: PortalButtonData) => { this.$emit("selectPortal", portalButtonData); } }
                            />
                        )
                    }
                </div>
            </div>
        );
    }
});
